module.exports = __webpack_public_path__ + "img/V800.ade7ad61.png";